// ===========================================
// Consent Hooks
// ===========================================

import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  acknowledgeConsent,
  declineConsent,
  updateMediaExposure,
  type AcknowledgeConsentPayload,
  type MediaExposure,
} from '../api/consent.api';

export function useAcknowledgeConsent() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      familyId,
      payload,
    }: {
      familyId: string;
      payload: AcknowledgeConsentPayload;
    }) => acknowledgeConsent(familyId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['userProfile'] });
      queryClient.invalidateQueries({ queryKey: ['families'] });
    },
  });
}

export function useDeclineConsent() {
  return useMutation({
    mutationFn: (familyId: string) => declineConsent(familyId),
  });
}

export function useUpdateMediaExposure() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      familyId,
      mediaExposure,
    }: {
      familyId: string;
      mediaExposure: Exclude<MediaExposure, 'PENDING'>;
    }) => updateMediaExposure(familyId, mediaExposure),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['userProfile'] });
      queryClient.invalidateQueries({ queryKey: ['families'] });
    },
  });
}
